export default __webpack_public_path__ + "static/media/timeline-arrow.546b212f.svg";